import GastosContainer from './GastosContainer';
export default GastosContainer;
